const dictionary = {
  ru: {
    home: "Главная",
    calendar: "График",
    salary: "Зарплата",
    feedbacks: "Отзывы",
    chats: "Чаты",
    chatsAccessDenied: "Нет доступа",
    you: "Вы - ",
    login: "Войти",
    record: "Записаться",
    feedback: "Обратная связь",
    masters: "Мастера",
    dayOff: "Перерыв",
    booked: "Забронировано",
    service: "Услуга",
    editBooking: "Редактирование слота",
    clientFound: "Клиент найден",
    clientsPhone: "Номер телефона клиента",
    clientsInstagram: "Инстаграм клиента",
    clientsTelegram: "Телеграм клиента",
    confirmRecord: "Записать",
    registerClient: "Создать клиента",
    success: "Сохранено",
    phoneRequired: "Телефон обязателен",
    registered: "Зарегистрирован",
    weekdays: ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"],
    confirm: "Подтверждение",
    smsCode: "Введите код из смс для подтверждения",
    enter: "Вход",
    phoneToLogin: "Укажите свой номер телефона для входа",
    phoneNumber: "Номер телефона",
    serviceList: "Список услуг",
    name: "Название",
    userName: "Имя",
    price: "Стоимость",
    time: "Время",
    status: "Статус",
    noData: "Данные не найдены",
    leaveFeedback: "Оставить отзыв",
    closeRecord: "Закрытие записи",
    finalPrice: "Итоговая стоимость",
    comment: "Комментарий",
    send: "Отправить",
    toClientsList: "Вернуться к списку клиентов",
    recordHistory: "История заказов",
    master: "Мастер",
    recordNumber: "Номер заказа ",
    photo: "Фото",
    edit: "Редактировать",
    commentsList: "Список отзывов",
    client: "Клиент",
    staff: "Сотрудник",
    yourProfile: "Ваш профиль",
    profileEdit: "Редактирование профиля",
    myServices: "Мои услуги",
    durationMinutes: "Время, мин",
    yourName: "Ваше имя",
    birthday: "Дата рождения",
    rating: "Рейтинг",
    rateClient: "Оставить отзыв клиенту",
    giveFeedback: "Оставить отзыв",
    back: "Назад",
    selectRecord: "Выбирите запись для отзыва",
    theRecord: "Запись",
    date: "Дата",
    cancel: "Отменить",
    author: "Автор",
    clientHimself: "Сам клиент",
    position: "Должность",
    experience: "Опыт",
    message: "Сообщение",
    toUsersList: "Вернуться к списку cотрудников",
    phoneNumberWithPassword: "Укажите номер телефона и пароль для входа",
    enterPassword: "Введите пароль",
    password: "Пароль",
    logout: "Выход",
    chatsLoadError: "Не удалось загрузить чаты",
    chatsThreadError: "Не удалось открыть диалог",
    chatsUploadError: "Не удалось загрузить файл",
    chatsEmpty: "Диалогов пока нет",
    chatsUnlinked: "Не связан",
    chatsClientNotFound: "Клиент не найден",
    chatsPhoto: "Фото",
    chatsPhotoPending: "Фото…",
    chatsPick: "Выберите диалог",
    chatsClaim: "Взять",
    chatsClose: "Закрыть диалог",
    chatsReopen: "Открыть снова",
    chatsClientPane: "Клиент",
    chatsDeleted: "Сообщение удалено",
    chatsWindowClosed: "Окно ответа 7 дней закрыто",
    chatsCannotReply: "Отправка недоступна",
    chatsClientHint: "Карточка клиента появится после выбора диалога",
    chatsOpenClient: "Открыть клиента",
    chatsUnlink: "Отвязать",
    chatsClientId: "ID клиента",
    chatsLink: "Связать",
    chatsCreateClient: "Создать клиента",
    chatsSuggestions: "Подсказки",
    chatsConversations: "Переписки",
    chatsNoConversations: "Связанных диалогов нет",
    chatsOpen: "В чаты",
    chatsUnreadOnly: "Непрочитанные",
    chatsLive: "Онлайн",
    chatsStatusSent: "Отправлено",
    chatsStatusRead: "Прочитано",
    chatsOffline: "Офлайн",
    chatsReconnect: "Переподключение…",
    chatsEnableNotifications: "Включить уведомления",
    chatsNotificationsOn: "Уведомления включены",
    chatsNotificationsDenied: "Уведомления заблокированы",
    chatsNotifySound: "Звук",
    chatsNewMessage: "Новое сообщение",
    chatsAssignee: "Ответственный",
    chatsLinked: "Связь установлена",
    chatsNextRecord: "Следующая запись",
    chatsScheduled: "Запланировано",
    chatsToday: "Сегодня",
    chatsYesterday: "Вчера",
    chatsTypeMessage: "Введите сообщение...",
    chatsBirthday: "Дата рождения",
    chatsLastVisit: "Последний визит",
    chatsTotalRecords: "Всего записей",
    chatsNote: "Заметка",
    chatsNoteEmpty: "Нет заметки",
    chatsOpenCard: "Открыть карточку",
    chatsAttachClient: "Прикрепить",
    chatsCreateCard: "Создать карточку",
    chatsCreateRecord: "Создать запись",
    chatsMine: "Мои",
    chatsStatusReplied: "Отвеченный",
    chatsStatusPending: "Ожидание",
    chatsStatusClosed: "Закрыт",
    chatsBackToChats: "Назад к чатам",
    chatsPhoneSearch: "Номер телефона",
    chatsClientFoundByPhone: "Клиент найден",
    chatsNameRequired: "Имя",
    staffNote: "Заметка",
    send: "Отправить",
    retry: "Повтор",
    back: "Назад",
    loading: "Загрузка…",
    close: "Закрыть",
    clientsName: "Имя клиента",
    firstMonth: [
      "января",
      "февраля",
      "марта",
      "апреля",
      "мая",
      "июня",
      "июля",
      "августа",
      "сентября",
      "октября",
      "ноября",
      "декабря",
    ],
    secondMonth: [
      "Январь",
      "Февраль",
      "Март",
      "Апрель",
      "Май",
      "Июнь",
      "Июль",
      "Август",
      "Сентябрь",
      "Октябрь",
      "Ноябрь",
      "Декабрь",
    ],
    calendarLanguage: "ru-ru",
    shortDays: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
    expShort: "Опыт",
    feedbackClient: "Отзыв",
    portfolio: "Портфолио",
    about: "О нас",
    team: "Команда",
    contact: "Контакты",
    unlock: "Откройте великолепие своей привлекательности",
    unlockLg: `Откройте силу вечной красоты с нашими изысканными услугами. Почувствуйте роскошное омоложение и божественное очарование, отправляясь в путешествие открытия истинной себя. Каждый момент раскроет ковер изящества, где каждая деталь отражает совершенство, пребывающее внутри. Наши вечные процедуры красоты поднимут вас на вершину изящного великолепия.`,
    portfolioTitle: "Наш проффесионализм",
    aboutTitle: "Разблокируйте Вечную Роскошь: Когда Красота Превышает Время",
    aboutDescr: "ЗДОРОВЫЕ НОГТИ",
    aboutDescrLg:
      "Почувствуйте вершину роскошной красоты и омоложения во Вечной Красоте. Отправьтесь в путешествие, чтобы раскрыть свою внутреннюю грацию и показать вечную элегантность, пребывающую внутри вас. Превратите свои ногти в изысканные произведения искусства с нашими роскошными услугами нейл-арт. Во Вечной Красоте мы приоритетно относимся к здоровью и жизненной силе ваших ногтей.",
    meet: "Встречайте нашу ",
    teamLow: "команду",
    cqs: "Специалист и директор по качеству",
    lm: "Старший мастер и руководитель смены",
    am: "Управляющий администратор",
    contacts: "Контакты",
    passwordRecovery: "Восстановить пароль",
    passwordRecoveryDescrcription:
      "Введите номер телефона, пароль придет в виде смс",
    recover: "Восстановить",
    all: "Все",
    mine: "Мои",
    created: "Созданые",
    completed: "Завершенные",
    canceled: "Отмененные",
    error: "Неудача",
    cameFrom: "Откуда узнали",
    complex: "Комплекс",
    currentSelection: "Текущий выбор",
    confirmComplex: "Подтвердите запись",
    communication: "Коммуникация",
    notFound: "Ой... Страница не найдена",
    history: "История",
    info: "Детали",
    fullHistory: "Вся история",
    monthHistory: "История за месяц",
    filter: "Фильтр",
    people: "Люди",
    displayed: "Отображаемые",
    hidden: "Скрытые",
    sortBy: "Сортировать по:",
    crmRegister: "Регистрация мастера",
    crmRegisterDescription:
      "Выберите салон и укажите телефон с паролем. Доступ к CRM выдаёт владелец салона после регистрации.",
    crmRegisterSubmit: "Зарегистрироваться",
    crmRegisterPending:
      "Регистрация прошла успешно. Дождитесь, пока владелец салона включит вам доступ сотрудника, затем войдите.",
    crmRegisterLink: "Регистрация мастера",
    chooseSalon: "Салон",
    chooseSalonPlaceholder: "Выберите салон",
    noSalonsForRegister: "Нет доступных салонов для регистрации",
    alreadyHaveAccount: "Уже есть аккаунт? Войти",
    clientLoginSmsFailed:
      "Не удалось отправить SMS с кодом. Обратитесь в салон.",
    clientLoginRecaptchaFailed:
      "Не удалось проверить reCAPTCHA. Обновите страницу или отключите блокировщик рекламы.",
    clientLoginCompanySlugRequired:
      "Откройте страницу входа через адрес вашего салона (поддомен salonium.pro).",
    clientLoginRateLimit:
      "Слишком много запросов кода. Подождите и попробуйте снова.",
    clientLoginInvalidCredentials: "Неверный телефон или код",
    clientLoginFailed: "Не удалось войти. Попробуйте ещё раз.",
    clientLoginPhoneIncomplete:
      "Введите полный номер телефона (+7… или +381…)",
    clientLoginRecaptchaLoading:
      "Загружается защита от ботов. Подождите пару секунд и нажмите снова.",
    clientLoginChecking: "Проверка…",
    clientLoginSending: "Отправка…",
  },
  en: {
    home: "Home",
    calendar: "Calendar",
    salary: "Salary",
    feedbacks: "Feedbacks",
    chats: "Chats",
    chatsAccessDenied: "Access denied",
    you: "You - ",
    login: "Login",
    record: "Record",
    feedback: "Feedback",
    masters: "Masters",
    dayOff: "Break",
    booked: "Reserved",
    service: "Service",
    editBooking: "Edit booking",
    clientFound: "Client found",
    clientsPhone: "Client's phone",
    clientsInstagram: "Client's instagram",
    clientsTelegram: "Client's telegram",
    confirmRecord: "Confirm record",
    registerClient: "Register client",
    success: "Success",
    phoneRequired: "Phone required",
    registered: "Registered",
    weekdays: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    confirm: "Confirm",
    smsCode: "Enter code from sms",
    enter: "Enter",
    phoneToLogin: "Enter your phone to login",
    phoneNumber: "Phone number",
    serviceList: "Service list",
    name: "Name",
    userName: "Name",
    price: "Price",
    time: "Time",
    status: "Status",
    noData: "No data found",
    leaveFeedback: "Leave feedback",
    closeRecord: "Close record",
    finalPrice: "Final price",
    comment: "Comment",
    send: "Send",
    toClientsList: "To users list",
    recordHistory: "Record history",
    master: "Master",
    recordNumber: "Record number ",
    photo: "Photo",
    edit: "Edit",
    commentsList: "Comment list",
    client: "Client",
    staff: "Staff",
    yourProfile: "Your profile",
    profileEdit: "Edit profile",
    myServices: "My services",
    durationMinutes: "Duration, min",
    yourName: "Your name",
    birthday: "Birthday",
    rating: "Rating",
    rateClient: "Leave feedback to client",
    giveFeedback: "Leave feedback",
    back: "Back",
    selectRecord: "Select record to rate",
    theRecord: "Record",
    date: "Date",
    cancel: "Cancel",
    author: "Author",
    clientHimself: "Client by himself",
    position: "Position",
    experience: "Experience",
    message: "Message",
    toUsersList: "To users list",
    phoneNumberWithPassword: "Enter phone number and password",
    enterPassword: "Enter password",
    password: "Password",
    logout: "Logout",
    chatsLoadError: "Failed to load chats",
    chatsThreadError: "Failed to open conversation",
    chatsUploadError: "Failed to upload file",
    chatsEmpty: "No conversations yet",
    chatsUnlinked: "Unlinked",
    chatsClientNotFound: "Client not found",
    chatsPhoto: "Photo",
    chatsPhotoPending: "Photo…",
    chatsPick: "Select a conversation",
    chatsClaim: "Claim",
    chatsClose: "Close chat",
    chatsReopen: "Reopen",
    chatsClientPane: "Client",
    chatsDeleted: "Message deleted",
    chatsWindowClosed: "7-day reply window closed",
    chatsCannotReply: "Sending unavailable",
    chatsClientHint: "Client card appears after selecting a conversation",
    chatsOpenClient: "Open client",
    chatsUnlink: "Unlink",
    chatsClientId: "Client ID",
    chatsLink: "Link",
    chatsCreateClient: "Create client",
    chatsSuggestions: "Suggestions",
    chatsConversations: "Conversations",
    chatsNoConversations: "No linked conversations",
    chatsOpen: "Open chats",
    chatsUnreadOnly: "Unread only",
    chatsLive: "Online",
    chatsStatusSent: "Sent",
    chatsStatusRead: "Read",
    chatsOffline: "Offline",
    chatsReconnect: "Reconnecting…",
    chatsEnableNotifications: "Enable notifications",
    chatsNotificationsOn: "Notifications on",
    chatsNotificationsDenied: "Notifications blocked",
    chatsNotifySound: "Sound",
    chatsNewMessage: "New message",
    chatsAssignee: "Assignee",
    chatsLinked: "Linked",
    chatsNextRecord: "Next appointment",
    chatsScheduled: "Scheduled",
    chatsToday: "Today",
    chatsYesterday: "Yesterday",
    chatsTypeMessage: "Type a message...",
    chatsBirthday: "Date of birth",
    chatsLastVisit: "Last visit",
    chatsTotalRecords: "Total bookings",
    chatsNote: "Note",
    chatsNoteEmpty: "No note",
    chatsOpenCard: "Open card",
    chatsAttachClient: "Attach",
    chatsCreateCard: "Create client",
    chatsCreateRecord: "Create booking",
    chatsMine: "Mine",
    chatsStatusReplied: "Replied",
    chatsStatusPending: "Waiting",
    chatsStatusClosed: "Closed",
    chatsBackToChats: "Back to chats",
    chatsPhoneSearch: "Phone number",
    chatsClientFoundByPhone: "Client found",
    chatsNameRequired: "Name",
    staffNote: "Note",
    send: "Send",
    retry: "Retry",
    back: "Back",
    loading: "Loading…",
    close: "Close",
    clientsName: "Client's name",
    firstMonth: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    secondMonth: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    calendarLanguage: "en-us",
    shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    expShort: "Exp.",
    feedbackClient: "Feedback",
    portfolio: "Portfolio",
    about: "About",
    team: "Team",
    contact: "Contect",
    unlock: "Unlock Your Glamour",
    unlockLg: `Unlock the power of timeless beauty with our exquisite services.
    Experience luxurious rejuvenation and divine allure as you embark on
    a journey to discover the ultimate you. Each moment will unfold a
    tapestry of elegance, where every detail reflects the perfection
    that resides within. Our timeless beauty treatments will elevate you
    to the pinnacle of graceful splendor.`,
    portfolioTitle: "Nails Proffesionals",
    aboutTitle: "Unlock Timeless Luxury: Where Beauty Transcends Time",
    aboutDescr: "Healthy Nails",
    aboutDescrLg:
      "Experience the pinnacle of luxurious beauty and rejuvenation at Timeless Beauty. Embark on a journey to unlock your inner grace and reveal the timeless elegance that resides within. Transform your nails into exquisite works of art with our luxurious nail artistry services. At Timeless Beauty, we prioritize the health and vitality of your nails.",
    meet: "Meet the ",
    teamLow: "team",
    cqs: "Chief Quality Specialist",
    lm: "Lead Master",
    am: "Administrative Manager",
    contacts: "Contacts",
    passwordRecovery: "Password recovery",
    passwordRecoveryDescrcription:
      "Enter your phone, password will be sent to you with sms",
    recover: "Recover",
    all: "All",
    mine: "Mine",
    created: "Created",
    completed: "Completed",
    canceled: "Canceled",
    error: "Error",
    cameFrom: "Came from",
    complex: "Complex",
    currentSelection: "Current selection",
    confirmComplex: "Confirm complex",
    communication: "Communication",
    notFound: "Oops... Page not found",
    history: "History",
    info: "Info",
    fullHistory: "Full History",
    monthHistory: "Month History",
    filter: "Filter",
    people: "People",
    displayed: "Displayed",
    hidden: "Hidden",
    sortBy: "Sort by:",
    crmRegister: "Master registration",
    crmRegisterDescription:
      "Choose a salon and enter your phone and password. The salon owner must grant staff access before CRM login.",
    crmRegisterSubmit: "Register",
    crmRegisterPending:
      "Registration successful. Wait for the salon owner to enable staff access, then sign in.",
    crmRegisterLink: "Register as master",
    chooseSalon: "Salon",
    chooseSalonPlaceholder: "Select a salon",
    noSalonsForRegister: "No salons available for registration",
    alreadyHaveAccount: "Already have an account? Sign in",
    clientLoginSmsFailed:
      "Could not send SMS with the code. Please contact the salon.",
    clientLoginRecaptchaFailed:
      "Could not verify reCAPTCHA. Refresh the page or disable your ad blocker.",
    clientLoginCompanySlugRequired:
      "Open the login page via your salon address (salonium.pro subdomain).",
    clientLoginRateLimit:
      "Too many code requests. Please wait and try again.",
    clientLoginInvalidCredentials: "Invalid phone or code",
    clientLoginFailed: "Login failed. Please try again.",
    clientLoginPhoneIncomplete: "Enter a complete phone number (+7… or +381…)",
    clientLoginRecaptchaLoading:
      "Security check is loading. Please wait and try again.",
    clientLoginChecking: "Checking…",
    clientLoginSending: "Sending…",
  },
  sr: {
    home: "Glavna",
    calendar: "Raspored",
    salary: "Plata",
    feedbacks: "Utisci",
    chats: "Ćaskanja",
    chatsAccessDenied: "Nema pristupa",
    you: "Vi - ",
    login: "Ući",
    record: "Upisati se",
    feedback: "Povratna informacija",
    masters: "Majstori",
    dayOff: "Slobodan dan",
    booked: "Upisano",
    service: "Usluga",
    editBooking: "Izmeniti termin",
    clientFound: "Klijent pronađen",
    clientsPhone: "Broj telefona klijenta",
    clientsInstagram: "Instagram klijenta",
    clientsTelegram: "Telegram klijenta",
    confirmRecord: "Upisati se",
    registerClient: "Kreirati klijenta",
    success: "Sačuvano",
    phoneRequired: "Telefon obavezan",
    registered: "Registrovan",
    weekdays: ["Pon", "Uto", "Sre", "Čet", "Pet", "Sub", "Ned"],
    confirm: "Potvrda",
    smsCode: "Unesite kod koji je stigao putem sms za potvrdu",
    enter: "Ulaz",
    phoneToLogin: "Upišite svoj broj telefona kako biste ušli",
    phoneNumber: "Broj telefona",
    serviceList: "Spisak usluga",
    name: "Naziv",
    userName: "Ime",
    price: "Cena",
    time: "Vreme",
    status: "Status",
    noData: "Podaci nisu pronađeni",
    leaveFeedback: "Podaci nisu pronađeni",
    closeRecord: "Podaci nisu pronađeni",
    finalPrice: "Ukupna suma",
    comment: "Komentari",
    send: "Poslati",
    toClientsList: "Vratite se na spisak klijenata",
    recordHistory: "Istorija upisanih klijenata",
    master: "Majstor",
    recordNumber: "Redni broj termina ",
    photo: "Fotografija",
    edit: "Izmeniti",
    commentsList: "Spisak utisaka",
    client: "Klijent",
    staff: "Zaposeni",
    yourProfile: "Vaš profil",
    profileEdit: "Izmeniti profil",
    myServices: "Moje usluge",
    durationMinutes: "Vreme, min",
    yourName: "Vaše ime",
    birthday: "Datum rođenja",
    rating: "Rejting",
    rateClient: "Napišite utisak klijentu",
    giveFeedback: "Napišite utisak",
    back: "Nazad",
    selectRecord: "Izaberite slot za utisak",
    theRecord: "Upisati",
    date: "Datum",
    cancel: "Otkazati",
    author: "Autor",
    clientHimself: "Klijent",
    position: "Dužnost",
    experience: "Iskustvo",
    message: "Poruka",
    toUsersList: "Vratiti se na spisak zaposlenih",
    phoneNumberWithPassword: "Unesite broj telefona i lozinku",
    enterPassword: "Unesite lozinku",
    password: "Lozinka",
    logout: "Izlaz",
    chatsLoadError: "Neuspelo učitavanje ćaskanja",
    chatsThreadError: "Neuspelo otvaranje dijaloga",
    chatsUploadError: "Neuspelo otpremanje fajla",
    chatsEmpty: "Još nema dijaloga",
    chatsUnlinked: "Nije povezan",
    chatsClientNotFound: "Klijent nije pronađen",
    chatsPhoto: "Foto",
    chatsPhotoPending: "Foto…",
    chatsPick: "Izaberite dijalog",
    chatsClaim: "Preuzmi",
    chatsClose: "Zatvori dijalog",
    chatsReopen: "Ponovo otvori",
    chatsClientPane: "Klijent",
    chatsDeleted: "Poruka obrisana",
    chatsWindowClosed: "Prozor odgovora od 7 dana je zatvoren",
    chatsCannotReply: "Slanje nije dostupno",
    chatsClientHint: "Kartica klijenta pojaviće se nakon izbora dijaloga",
    chatsOpenClient: "Otvori klijenta",
    chatsUnlink: "Odveži",
    chatsClientId: "ID klijenta",
    chatsLink: "Poveži",
    chatsCreateClient: "Kreiraj klijenta",
    chatsSuggestions: "Predlozi",
    chatsConversations: "Prepiske",
    chatsNoConversations: "Nema povezanih dijaloga",
    chatsOpen: "U ćaskanja",
    chatsUnreadOnly: "Nepročitano",
    chatsLive: "Online",
    chatsStatusSent: "Poslato",
    chatsStatusRead: "Pročitano",
    chatsOffline: "Offline",
    chatsReconnect: "Ponovno povezivanje…",
    chatsAssignee: "Odgovorni",
    chatsLinked: "Veza uspostavljena",
    chatsNextRecord: "Sledeći termin",
    chatsScheduled: "Zakazano",
    chatsToday: "Danas",
    chatsYesterday: "Juče",
    chatsTypeMessage: "Unesite poruku...",
    chatsBirthday: "Datum rođenja",
    chatsLastVisit: "Poslednja poseta",
    chatsTotalRecords: "Ukupno termina",
    chatsNote: "Beleška",
    chatsNoteEmpty: "Nema beleške",
    chatsOpenCard: "Otvori karticu",
    chatsAttachClient: "Poveži",
    chatsCreateCard: "Kreiraj karticu",
    chatsCreateRecord: "Kreiraj termin",
    chatsMine: "Moja",
    chatsStatusReplied: "Odgovoreno",
    chatsStatusPending: "Čekanje",
    chatsStatusClosed: "Zatvoreno",
    chatsBackToChats: "Nazad na ćaskanja",
    chatsPhoneSearch: "Broj telefona",
    chatsClientFoundByPhone: "Klijent pronađen",
    chatsNameRequired: "Ime",
    staffNote: "Beleška",
    send: "Pošalji",
    retry: "Ponovi",
    back: "Nazad",
    loading: "Učitavanje…",
    close: "Zatvoriti",
    clientsName: "Ime klijenta",
    firstMonth: [
      "Januara",
      "Februara",
      "Marta",
      "Aprila",
      "Maja",
      "Juna",
      "Jula",
      "Avgusta",
      "Septembra",
      "Octobra",
      "Novembra",
      "Decembra",
    ],
    secondMonth: [
      "Januar",
      "Februar",
      "Mart",
      "April",
      "Maj",
      "Jun",
      "Jul",
      "Avgust",
      "Septembar",
      "Octobar",
      "Novembar",
      "Decembar",
    ],
    calendarLanguage: "en-us",
    shortDays: ["Pon", "Uto", "Sre", "Čet", "Pet", "Sub", "Ned"],
    expShort: "Isk.",
    feedbackClient: "Utisak",
    portfolio: "Portfolio",
    about: "O nama",
    team: "Tim",
    contact: "Kontakt",
    unlock: "Otkrijte sjaj svoje lepote",
    unlockLg: `Unlock the power of timeless beauty with our exquisite services.
    Experience luxurious rejuvenation and divine allure as you embark on
    a journey to discover the ultimate you. Each moment will unfold a
    tapestry of elegance, where every detail reflects the perfection
    that resides within. Our timeless beauty treatments will elevate you
    to the pinnacle of graceful splendor.`,
    portfolioTitle: "Naš profesionalizam",
    aboutTitle: "Otkrijte večnu raskoš: Kada je lepota izvan vremena",
    aboutDescr: "ZDRAVI NOKTI",
    aboutDescrLg:
      "Doživite vrhunac luksuzne lepote u Timeless Beauty. Krenite na putovanje u kom ćete osloboditi svoju unutrašnju gracioznost i otkriti bezvremensku eleganciju koja se nalazi u Vama. Pretvorite svoje nokte u izuzetna umetnička dela uz naše luksuzne usluge nail - art. U Timeless Beauty salonu prioritet je zdravlje Vaših noktiju.",
    meet: "Upoznajte naš ",
    teamLow: "tim",
    cqs: "Specijalista i direktor kvaliteta",
    lm: "Stariji majstor i rukovodilac smene",
    am: "Glavni administrator",
    contacts: "Kontakt",
    passwordRecovery: "Resetujte lozinku",
    passwordRecoveryDescrcription:
      "Unesite broj telefona, lozinka će Vam stići putem SMS poruke",
    recover: "Resetovati",
    all: "Sve",
    mine: "Moji",
    created: "Kreirani",
    completed: "Završeni",
    canceled: "Otkazani",
    error: "Greška",
    cameFrom: "Kako ste čuli za nas",
    complex: "Raspon",
    currentSelection: "Trenutni izbor",
    confirmComplex: "Potvrda respon",
    communication: "Communication",
    notFound: "Упс... Страница није пронађена",
    history: "History",
    info: "Info",
    fullHistory: "Full History",
    monthHistory: "Month History",
    filter: "Filter",
    people: "Ljudi",
    displayed: "Prikazani",
    hidden: "Sakriveni",
    sortBy: "Sortirati po:",
    crmRegister: "Registracija majstora",
    crmRegisterDescription:
      "Izaberite salon i unesite telefon i lozinku. Vlasnik salona mora da omogući pristup zaposlenom pre CRM prijave.",
    crmRegisterSubmit: "Registracija",
    crmRegisterPending:
      "Registracija je uspešna. Sačekajte da vlasnik salona omogući pristup zaposlenom, zatim se prijavite.",
    crmRegisterLink: "Registracija majstora",
    chooseSalon: "Salon",
    chooseSalonPlaceholder: "Izaberite salon",
    noSalonsForRegister: "Nema dostupnih salona za registraciju",
    alreadyHaveAccount: "Već imate nalog? Prijavite se",
    clientLoginSmsFailed:
      "Nije moguće poslati SMS sa kodom. Obratite se salonu.",
    clientLoginRecaptchaFailed:
      "Nije moguće proveriti reCAPTCHA. Osvežite stranicu ili isključite blokator reklama.",
    clientLoginCompanySlugRequired:
      "Otvorite stranicu za prijavu preko adrese vašeg salona (salonium.pro poddomen).",
    clientLoginRateLimit:
      "Previše zahteva za kod. Sačekajte i pokušajte ponovo.",
    clientLoginInvalidCredentials: "Pogrešan telefon ili kod",
    clientLoginFailed: "Prijava nije uspela. Pokušajte ponovo.",
    clientLoginPhoneIncomplete:
      "Unesite pun broj telefona (+7… ili +381…)",
    clientLoginRecaptchaLoading:
      "Učitava se zaštita od botova. Sačekajte par sekundi i pokušajte ponovo.",
    clientLoginChecking: "Provera…",
    clientLoginSending: "Slanje…",
  },
}
export default dictionary
